import { useState } from 'react';
import { FaTimes, FaExpand } from 'react-icons/fa';
import Lightbox from './Lightbox';

const ServiceGalleryModal = ({ service, images, onClose }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Check if images are featured
  const isFeatured = (image) => {
    return service.featuredImageFilenames?.includes(image.filename);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">{service.name} Gallery</h2>
            <p className="text-gray-600">
              {images.length} {images.length === 1 ? 'photo' : 'photos'}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <FaTimes className="w-6 h-6 text-gray-600" />
          </button>
        </div>

        {/* Gallery Grid */}
        <div className="overflow-y-auto max-h-[calc(90vh-120px)] p-6">
          {images.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {images.map((image, index) => (
                <div
                  key={image.id}
                  onClick={() => setSelectedImageIndex(index)}
                  className="relative group cursor-pointer overflow-hidden rounded-lg aspect-square"
                >
                  <img
                    src={image.thumbnail || image.url}
                    alt={image.alt || `${service.name} project`}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      {isFeatured(image) && (
                        <span className="inline-block bg-primary-600 text-white text-xs px-2 py-1 rounded mb-1">
                          Featured
                        </span>
                      )}
                      {image.title && image.title !== image.filename && (
                        <p className="text-white text-sm font-medium line-clamp-2">
                          {image.title}
                        </p>
                      )}
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <FaExpand className="text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-gray-500">No images available for this service.</p>
            </div>
          )}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImageIndex !== null && (
        <Lightbox
          images={images}
          selectedIndex={selectedImageIndex}
          onClose={() => setSelectedImageIndex(null)}
          onNavigate={setSelectedImageIndex}
        />
      )}
    </div>
  );
};

export default ServiceGalleryModal;